import React, { useEffect, useState } from "react";
import { convertRS } from "../../utlits";

export interface IOS_UserDetailsProps {
  dbData: any;
}

const OS_UserDetails: React.FC<IOS_UserDetailsProps> = (props) => {
  const [userDetails, setUserDetails] = useState<any>({
    email: "",
    phone: "",
    totalAcptConsn: "",
    totalDeclineConsn: "",
    netApiCount: "",
  });

  useEffect(() => {
    if (props.dbData && props.dbData.myInfo) {
      setUserDetails({
        ...userDetails,
        email: props.dbData.myInfo.email,
        phone: props.dbData.myInfo.phn,
        totalAcptConsn: props.dbData.clntAcptCnsnt,
        totalDeclineConsn: props.dbData.clntDecCnsnt,
        netApiCount: props.dbData.netApiCount
          ? convertRS(props.dbData.netApiCount, 2)
          : 0,
      });
    } else {
      setUserDetails({
        email: "",
        phone: "",
        totalAcptConsn: 0,
        totalDeclineConsn: 0,
        netApiCount: 0,
      });
    }
  }, [props.dbData]);

  return (
    <div className="os_userDetails">
      <div className="statistics_details">
        <div className="user_statistics">
          <p>Total API Requests</p>
          <h5>{userDetails.netApiCount}</h5>
        </div>
        <div className="user_statistics">
          <p>Users Accepted Consent</p>
          <h5>{userDetails.totalAcptConsn}</h5>
        </div>
        <div className="user_statistics">
          <p>User Denied Consent</p>
          <h5>{userDetails.totalDeclineConsn}</h5>
        </div>
      </div>
      <div className="user_details">
        <h4>My Information </h4>
        <div>
          <p>{userDetails.email}</p>
          <p>{userDetails.phone}</p>
        </div>
      </div>
    </div>
  );
};

export default OS_UserDetails;
